export async function cancelShippingGuidesUseCase(guide_ids, guideRepostitory) {
    const result = await guideRepostitory.cancel_guides(guide_ids);

    return result;
}